module.exports = __webpack_public_path__ + "img/ic_disciplines_specialties.686e5319.svg";